// FC-011 item 4: pure helper for the WordAG generator OPTIONS-RETURN merge.
//
// The WordAG save pipeline (actions/flinkMakeActions/wordlists.js) seeds a generated
// activity's options from template.defaultOptions, then lets a template generator
// optionally RETURN `options` to override specific keys for ITS generated activities
// only. This helper is that merge, kept pure + barrel-free so the cross-template
// guarantee is unit-testable:
//   - a generator that returns no options (every template except FLASH_CARDS today)
//     leaves baseOptions byte-identical (same reference semantics as before);
//   - a generator that returns an options object has its keys win over the base.
// Arrays / non-objects are ignored (treated as "no options") so an old generator
// returning options:[] cannot blank the activity options.
export function mergeGeneratedOptions(baseOptions, generatedOptions) {
  const base = baseOptions || {};
  if (!generatedOptions || typeof generatedOptions !== 'object' || Array.isArray(generatedOptions)) {
    return base; // unchanged — other templates are completely unaffected
  }
  return { ...base, ...generatedOptions };
}
